import React, { useEffect, useMemo, useRef } from 'react';
import Highcharts from 'highcharts';

const ChartMonthly = ({ report_dealerships, report_title, data }) => {
  const chartRef = useRef(null);

  // Memoize the series data to avoid unnecessary recalculations
  const seriesArray = useMemo(() => {
    return report_dealerships.split(',').map((dealership) => {
      if (dealership) {
        const seriesData = data.yAxis?.[dealership] || [];
        return {
          name: dealership,
          data: seriesData,
          tooltip: {
            valueSuffix: ' Days',
          },
        };
      }
      return null;
    }).filter(Boolean);
  }, [report_dealerships, data]);

  useEffect(() => {
    if (!data.xAxis) {
      return;
    }

    // Render the chart
    chartRef.current = Highcharts.chart('monthly-chart', {
      chart: {
        type: 'column',
        backgroundColor: null,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: report_title,
      },
      xAxis: {
        categories: data.xAxis,
        crosshair: true,
        labels: {
          style: {
            color: 'black',
          },
        },
      },
      yAxis: {
        labels: {
          format: '{value} Days',
          style: {
            color: 'black',
          },
        },
        title: {
          text: 'Average Recon Times',
        },
      },
      tooltip: {
        shared: true,
        valueDecimals: 1,
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        floating: false,
        itemStyle: {
          color: 'black',
          fontSize: '11px',
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            rotation: -90,
            color: '#000',
            align: 'right',
            format: '{point.y:.1f}',
            y: 10,
            style: {
              fontSize: '13px',
              color: '#000',
              fontFamily: 'Verdana, sans-serif',
            },
          },
        },
        series: {
          cursor: 'pointer',
          point: {
            events: {
              click() {
                alert(`Department: ${this.category}, Days: ${this.y}`);
              },
            },
          },
        },
      },
      series: seriesArray,
    });

    // Cleanup function to dispose of the chart
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!chartRef.current || !data.xAxis) return;
    const chart = chartRef.current;
    chart.update({
      title: { text: report_title },
      xAxis: { categories: data.xAxis },
      series: seriesArray,
    }, true, true);
    const legendHeight = chart.legend?.legendHeight || 0;
    const targetHeight = 340 + legendHeight;
    if (Math.abs((chart.chartHeight || 0) - targetHeight) > 4) {
      chart.setSize(undefined, targetHeight, false);
    }
  }, [seriesArray, report_title, data.xAxis]);

  return (
    <div className="container space-top-1 space-bottom-1 pad-bottom-1 pad-top-2 bg-light shadow_4">
      <div id="monthly-chart" />
    </div>
  );
};

export default React.memo(ChartMonthly);